import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import OrderReportPrintParams from "./OrderRequestsModel/OrderReportPrintParams"

export default function OrderReportPrintObservable(params: OrderReportPrintParams): Observable<string> {
  const requestBody: string = JSON.stringify({
    SendToEmail: false,
    EmailAddress: [],
    TestDetailIDs: params.TestDetailIDs,
    TestDetailClinicalIDs: params.TestDetailClinicalIDs,
    PersonID: params.PersonID,
    VendorID: params.VendorID,
    XMLFile: params.XMLFile,
    ClientDetails: {
      // TODO: ContactID: VALUESTORAGE.CONTACT_ID
    },
  })

  return ObservableFromFetch<string>("WorkforceReport/AuthorizationFormReport", requestBody)
}